import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {Platform, PlatformUrl} from '@bca-core/models/_enums';
import {BCA_PLATFORM} from '@bca-core/models/platform';
import {AppModule} from '@bca/app.module';
import {environment} from '@environments/environment';
import {defineCustomElements} from '@nessie/webcomponents/loader';
import { getNessieAssetPath } from "@nessie/webcomponents";

if (environment.production) {
  enableProdMode();
}

const hostname = window.location.hostname || PlatformUrl.PRODUCTION;
const platform = hostname.includes(PlatformUrl.PRODUCTION) ? Platform.PRODUCTION
  : hostname.includes(PlatformUrl.ACCEPTANCE) ? Platform.ACCEPTANCE
  : hostname.includes(PlatformUrl.TEST) ? Platform.TEST
  : hostname.includes(PlatformUrl.TEST2) ? Platform.TEST2
  : hostname.includes(PlatformUrl.TESTAUT) ? Platform.TESTAUT
  : Platform.DEVELOPMENT;

platformBrowserDynamic([{ provide: BCA_PLATFORM, useValue: platform }])
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

declare let __webpack_public_path__: any;

if (
  platform == Platform.PRODUCTION ||
  platform == Platform.ACCEPTANCE ||
  platform == Platform.TEST || platform == Platform.TEST2 || platform == Platform.TESTAUT
) {
  const assetsPath = window.config.staticsPath;
  __webpack_public_path__ = assetsPath;
} 

defineCustomElements(window, {
  resourcesUrl: getNessieAssetPath(),
});
